import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../hooks/useUser';
import { toast } from 'react-toastify';

const ProtectedRoute = ({ children, allowedRoles }) => {
    const { data: user, isLoading, error } = useUser();
    const location = useLocation();
    

    if(error)
    {
        toast.error("Error found");
    }

    if (isLoading) {
        // Show a modern spinner while loading
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (!user) {
        console.log('🔒 ProtectedRoute - No user found, redirecting to login');
        // If there's no user, redirect to login and preserve intended path
        return <Navigate to="/" state={{ from: location.pathname }} replace />;
    }

    if (allowedRoles && !allowedRoles.includes(user.role)) {
        // If the user's role is not allowed, redirect to an unauthorized page
        return <Navigate to="/unauthorized" replace />;
    }

    // If the user is authenticated and has the correct role, render the children
    return children;
};

export default ProtectedRoute;